module.exports = __webpack_public_path__ + "img/buy.fb167ab8.svg";